import React, {useContext} from 'react';
import styles from "./Modal.module.css"
import noteContext from '../Context/NoteContext';
export default function Modal({children,categoryChild}) {

    const {
        isModal, setisModal
    } = useContext(noteContext);
    
    return (
        <div className={`${styles.overlay} ${isModal?styles.open:""}`} onClick={()=>setisModal(false)}>
            <div className={`${styles.modal} ${isModal?styles.open:""}`} onClick={e=>e.stopPropagation()}>
                <div className={styles.top}>
                    <div style={{fontSize:"1.3rem"}}><b>Add Expense/Income</b></div>
                    <div className={styles.x} onClick={()=>setisModal(false)}><div >X</div></div>
                </div>
                <div className={styles.child}>
                <div>{children}</div>
                </div>
                <div></div>
            </div>
        </div>
    )
}